// reducers/door/doors.js

export function doorsHasErrored(state = false, action) {
  switch (action.type) {
    case 'DOORS_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function doorsIsLoading(state = false, action) {
  switch (action.type) {
    case 'DOORS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function doors(state = [], action) {
  switch (action.type) {
    case 'DOORS_FETCH_DATA_SUCCESS':
      return action.list;
    default:
      return state;
  }
}